import { render, staticRenderFns } from "./LiveAssignmentVehicleList.vue?vue&type=template&id=399e40a6"
import script from "./LiveAssignmentVehicleList.vue?vue&type=script&lang=js"
export * from "./LiveAssignmentVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports